import Backbone from 'backbone';
import User from './user';
var UserCollection = Backbone.Collection.extend({
    model: User
});
export default UserCollection;
